import React from 'react';
import ReactTooltip from 'react-tooltip';

export default () => <ReactTooltip className="ttp" arrowColor="rgba(68, 85, 95, .95)" offset={{top: -7}} type="dark" effect="solid" />;
